<!--
Survey view with different layout modes.

@unstable
-->

<div
  class="z-container-box z-cover zef-survey"
  ngClass="zef-survey-{{ surveyKey }} z-size-{{ ss.viewSize | async }}"
  [class.z-has-multiple]="hasMultiple | async"
  [ngStyle]="(ss.font | async)?.styles"
  [@surveyState]="ss.viewState | async"
  (@surveyState.start)="disableAnimation.next(true)"
  (@surveyState.done)="onSurveyAnimationDone()"
  (mediaChange)="ss.viewSize.next($event)"
  (elementResize)="onViewResize($event)"
  (dragstart.ncds)="noop()"
  #surveyView
>
  <div
    class="z-cover"
    [style.filter]="(ss.background | async)?.filter | safeStyle"
    [ngStyle]="(ss.background | async)?.styles"
    [style.background-image]="(ss.background | async)?.image | safeStyle"
  ></div>

  <div class="z-cover" [style.background-color]="(ss.background | async)?.brightness"></div>
  <div class="z-cover" [style.background-color]="(ss.colors | async)?.moodOpacity"></div>

  @if ((hasMultiple | async) === false) {
    <div class="z-cover" [style.background-color]="(ss.colors | async)?.moodOpacity"></div>
  }
  @if ((ss.hideContent$ | async) === false && (sizeError | async); as error) {
    <mat-icon class="z-size-error" fontSet="zefplayer" [style.color]="(ss.colors | async)?.primary">
      {{ error }}
    </mat-icon>
  } @else {
    @if ((lm.loadingLanguage | async) || (ss.viewState | async) === states.Loading) {
      <zef-logo-spinner></zef-logo-spinner>
    } @else {
      <ng-scrollbar class="z-perfect-scroll" [class.z-no-cards]="(hasMultiple | async) === false">
        <div
          class="z-cards-scroll z-fx-col"
          [ngClass]="'z-viewstate-' + (ss.viewState | async)"
          surveyScroller
          [disabledInitialFocus]="disabledInitialFocus"
          [disabled]="
            (ss.disableScroll | async) || cardAnimation.getValue() || (ss.viewState | async) !== states.Questions
          "
          [touchScreen]="touchScreen"
          (scrollUp)="changeIdx(-1)"
          (scrollDown)="changeIdx(1)"
        >
          <div
            class="z-fx-auto z-main-container"
            [class.z-card-outer]="(hasMultiple | async) === false"
            [style.padding-top.px]="(hasMultiple | async) === false ? (topMargin$ | async) : 0"
            [@.disabled]="disableAnimation | async"
          >
            <div
              class="z-cards-container z-fx-auto"
              [style.overflow]="cardAnimation.getValue() ? 'hidden' : null"
              [style.min-height.px]="(hasMultiple | async) ? (ss.viewRect$ | async)?.height : null"
              [class.z-card]="(hasMultiple | async) === false"
              #cardContainer
            >
              @switch (ss.viewState | async) {
                @case (states.Welcome) {
                  <welcome-card
                    [isAnonymous]="isAnonymous"
                    [showLanguageSelector]="showLanguageSelector | async"
                  ></welcome-card>
                }
                @case (states.Questions) {
                  @if (ss.cardQuestions | async; as cardQuestions) {
                    @if (cardQuestions?.length) {
                      @for (
                        question of cardQuestions;
                        track trackBy$Key(index, question);
                        let index = $index;
                        let last = $last
                      ) {
                        @if ((checkedIndex | async) === index) {
                          <card-scroll
                            class="z-fx-col z-fx-none"
                            ngClass="z-size-{{ ss.viewSize | async }}"
                            [fixed]="isFixedHeight(question)"
                            [first]="!index"
                            [last]="last"
                            [@cardScroll]="{
                              value: ss.scrollDir | async,
                              params: { height: (ss.viewRect$ | async)?.height },
                            }"
                            (@cardScroll.start)="cardAnimation.next(true)"
                            (@cardScroll.done)="onScrollAnimationDone()"
                          >
                            @if (index === 0 && (showLanguageSelector | async)) {
                              <div #lb class="z-fx-center-center z-fx-col z-language-box">
                                <div
                                  class="z-dropdown-preview z-fx z-fx-center-center z-fx-gap-4"
                                  [style.color]="(ss.colors | async).moodContrast"
                                  (click.s)="isLanguageBoxOpen = true"
                                >
                                  <figure [ngClass]="flagClass(lm.currentLanguageCode)"></figure>
                                  <span class="z-lang-name" [style.color]="(ss.colors | async).text">
                                    {{ lm.currentLanguageName }}
                                  </span>
                                  <mat-icon
                                    fontSet="zefplayer"
                                    class="z-dropdown-icon"
                                    [style.color]="(ss.colors | async).text"
                                  >
                                    arrow_down
                                  </mat-icon>
                                </div>
                                <div class="z-dropdown-holder z-fx-auto">
                                  @if (isLanguageBoxOpen) {
                                    <div class="z-language-overlay">
                                      <div class="z-dropdown-container">
                                        <language-select
                                          [locales]="lm.languages"
                                          [selected]="lm.currentLanguageCode"
                                          [clickOutsideActive]="isLanguageBoxOpen"
                                          (clickOutside)="isLanguageBoxOpen = false"
                                          (select)="isLanguageBoxOpen = false; lm.setLanguage($event)"
                                        ></language-select>
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                            <div
                              class="z-card z-card-inner z-fx-auto"
                              [id]="'zef-question-' + question.$key"
                              [style.background-color]="(ss.colors | async)?.moodOpacity"
                              [class.z-card-fixed]="isFixedHeight(question)"
                              [class.z-card-group]="Questions.info(question)"
                              [class.z-card-archived]="question?.archived"
                            >
                              @if (question?.archived) {
                                <span class="z-texts-question">This question is archived.</span>
                              }
                              <div #qw class="z-question-wrap" [class.z-fixed]="Questions.slider(question)">
                                <question-card
                                  [ngClass]="'z-size-' + (ss.viewSize | async)"
                                  [style.height.px]="!isFixedHeight(question) ? null : qw.offsetHeight"
                                  [class.z-fixed]="isFixedHeight(question)"
                                  [no]="
                                    (ss.showQuestionNumbers | async)
                                      ? (ss.normalQuestions | async)?.indexOf(question) + 1
                                      : 0
                                  "
                                  [active]="(disableAnimation | async) === false"
                                  [isLast]="last"
                                  [answerValue]="(ss.answers | async)[question.$key]"
                                  [questionData]="question"
                                  (nextQuestion)="onNextQuestion()"
                                  (prevQuestion)="changeIdx(-1)"
                                  (activeChanged)="activeChanged.emit($event)"
                                  (answerChanged)="onAnswerChanged($event)"
                                  (waitNext)="waitNext = $event === -1 ? question.$key : ''"
                                ></question-card>
                                <ng-container
                                  [ngTemplateOutlet]="buttonWrapper"
                                  [ngTemplateOutletContext]="{ $implicit: question.$key }"
                                ></ng-container>
                              </div>
                            </div>
                          </card-scroll>
                        }
                      }
                    } @else {
                      <div class="z-fx-between-center z-fx-col z-fx-fill z-no-items">
                        <div class="z-fx-center-center z-fx-col z-no-items-header z-fx-gap-32">
                          @if (ss.logo | async; as logo) {
                            @if ((welcomeCardShown | async) === false) {
                              @if (logo?.url) {
                                <div class="z-fx-center-center z-fx-col z-fx-flex-center z-no-items-header-logo">
                                  <img class="z-survey-logo" [src]="logo.url" alt="logo" />
                                </div>
                              } @else {
                                <div class="z-fx-center-center z-fx-col z-fx-flex-center z-no-items-header-no-logo">
                                  <mat-icon fontSet="zefplayer" [style.color]="(ss.colors | async).text">
                                    placeholder
                                  </mat-icon>
                                </div>
                              }
                            } @else {
                              <div class="z-fx-center-center z-fx-col z-fx-flex-center z-no-items-header-no-logo">
                                <mat-icon fontSet="zefplayer" [style.color]="(ss.colors | async).text">
                                  placeholder
                                </mat-icon>
                              </div>
                            }
                          }
                          <span class="z-title-text" [style.color]="(ss.colors | async).text">
                            {{
                              'Looks like there are no open questions at the moment'
                                | translateText: 'noQuestionsAvailable'
                            }}
                          </span>
                        </div>
                        <div class="z-fx-col z-fx-end-center z-no-items-content z-fx-gap-24">
                          <brand-wordmark
                            class="z-fx z-fx-center-center z-zef-logo"
                            [color]="(ss.colors | async).text50"
                          ></brand-wordmark>
                        </div>
                      </div>
                    }
                  }
                }
                @case (states.Outcomes) {
                  @if (hasMultiple | async) {
                    @for (
                      outcome of ss.scoredOutcomes | async;
                      track trackByScoredOutcome(index, outcome);
                      let index = $index;
                      let last = $last
                    ) {
                      <div
                        class="z-card z-card-inner z-card-outcome"
                        [id]="'zef-outcome-' + outcome.item.$key"
                        [style.background-color]="(ss.colors | async)?.moodOpacity"
                        [@cardScroll]="{
                          value: ss.scrollDir | async,
                          params: { height: (ss.viewRect$ | async)?.height },
                        }"
                        (@cardScroll.start)="cardAnimation.next(true)"
                        (@cardScroll.done)="onScrollAnimationDone()"
                      >
                        <div class="z-outcome-wrap">
                          <outcome-card
                            [id]="'outcome-' + index"
                            [isFirstOutcome]="index === 0"
                            [isLastOutcome]="last"
                            [ngClass]="'z-size-' + (ss.viewSize | async)"
                            [outcomeData]="outcome.item"
                            (newAnswerer)="onResetAnswers()"
                          ></outcome-card>
                        </div>
                      </div>
                    }
                  } @else {
                    @if (hasThankYouProperties | async) {
                      @if (
                        (ss.survey | async).results === Outcomes.GOODBYE
                          ? (ss.thanksOutcome | async)
                          : (ss.scoredOutcomes | async)[0]?.item;
                        as outcome
                      ) {
                        <outcome-card
                          [id]="'zef-outcome-' + outcome.$key"
                          [isFirstOutcome]="true"
                          [isLastOutcome]="true"
                          [outcomeData]="outcome"
                          (newAnswerer)="onResetAnswers()"
                          (changeAnswers)="onShowQuestions()"
                        ></outcome-card>
                      }
                    } @else {
                      <div class="z-fx-between-center z-fx-col z-fx-fill z-no-items">
                        <div class="z-fx-center-center z-fx-col z-no-items-header z-fx-gap-32">
                          @if (ss.logo | async; as logo) {
                            @if (logo?.url) {
                              <div class="z-fx-center-center z-fx-col z-fx-flex-center z-no-items-header-logo">
                                <img class="z-survey-logo" [src]="logo.url" alt="logo" />
                              </div>
                            } @else {
                              <div class="z-fx-center-center z-fx-col z-fx-flex-center z-no-items-header-no-logo">
                                <mat-icon fontSet="zefplayer" [style.color]="(ss.colors | async).text">reward</mat-icon>
                              </div>
                            }
                          }
                          <span class="z-title-text" [style.color]="(ss.colors | async).text">
                            {{ 'Thank you for answering' | translateText: 'genericThankYou' }}
                          </span>
                        </div>
                        <div class="z-fx-col z-fx-end-center z-no-items-content z-fx-gap-24">
                          <brand-wordmark
                            class="z-fx z-fx-center-center z-zef-logo"
                            [color]="(ss.colors | async).text50"
                          ></brand-wordmark>
                        </div>
                      </div>
                    }
                  }
                }
              }
              @if (
                (hasMultiple | async) === false &&
                ((ss.viewState | async) !== states.Outcomes || (ss.survey | async)?.results === Outcomes.GOODBYE) &&
                !((ss.viewState | async) === states.Questions && !(ss.cardQuestions | async)?.length)
              ) {
                <ng-container [ngTemplateOutlet]="buttonWrapper"></ng-container>
              }
              @if (hasMultiple | async) {
                <div
                  class="z-card-after"
                  [class.z-hidden]="
                    cardAnimation.getValue() ||
                    (ss.activeIdx | async) ===
                      ((ss.viewState | async) === states.Questions
                        ? (ss.cardQuestions | async)
                        : (ss.scoredOutcomes | async)
                      )?.length -
                        1
                  "
                  [style.background-color]="(ss.colors | async)?.moodOpacity"
                ></div>
              }
            </div>
          </div>
        </div>
      </ng-scrollbar>
      @if (ss.showFunnels | async) {
        <zef-funnel (answerChanged)="onAnswerChanged($event)"></zef-funnel>
      }
      @if (hasMultiple | async) {
        <div
          class="z-cover z-scrollbar-container"
          [style.top.px]="topMargin$ | async"
          [style.height]="'calc(100% - ' + (topMargin$ | async) + 'px)'"
        >
          <div class="z-scrollbar">
            @if ((ss.isMobile | async) === false) {
              <ng-container [ngTemplateOutlet]="menuButton"></ng-container>
            }
            @if ((ss.viewState | async) === states.Questions) {
              @if ((ss.isMobile | async) === false) {
                <div class="z-progress-text z-texts-hint">
                  {{ ss.percentCompleted | async | percent }}
                </div>
              }
              <questions-scrollbar
                [index]="ss.activeIdx | async"
                [answers]="ss.answers | async"
                (openMenu)="openMenu()"
                [ngClass]="'z-size-' + (ss.viewSize | async)"
                (change)="setActiveIdx($event)"
              ></questions-scrollbar>
              @if ((ss.isMobile | async) === false) {
                <div class="z-prev-next">
                  <ng-container [ngTemplateOutlet]="prevButton"></ng-container>
                  <ng-container [ngTemplateOutlet]="nextButton"></ng-container>
                </div>
              }
            }
            @if ((ss.viewState | async) === states.Outcomes) {
              <outcomes-scrollbar
                [index]="ss.activeIdx | async"
                [ngClass]="'z-size-' + (ss.viewSize | async)"
                (change)="changeOutcome($event)"
              ></outcomes-scrollbar>
            }
          </div>
        </div>
      }
      @if (showMenu) {
        <drawer-menu
          class="z-cover z-fx-col z-menu-container"
          [isAnonymous]="isAnonymous"
          (restart)="onResetAnswers()"
          (close)="closeMenu()"
        ></drawer-menu>
      }
      @if ((ss.viewState | async) === states.Outcomes) {
        <mat-icon
          fontSet="zefplayer"
          class="z-button-top"
          [class.z-jump]="(ss.activeIdx | async) === 0"
          [style.color]="(ss.colors | async).button"
          [style.background-color]="(ss.colors | async).buttonContrast"
          (click)="onOutcomeArrowClick()"
        >
          {{ (ss.activeIdx | async) ? 'arrow_up' : 'jump_top' }}
        </mat-icon>
      }
      @if (showButtonContainer | async) {
        <div
          class="z-fx-center-center z-fx-col"
          [class.z-floating-container]="floatingButtonContainer | async"
          [style.background-color]="
            (showFloatingContainerBackground | async) ? (ss.colors | async)?.mood : 'transparent'
          "
        >
          <div
            class="z-button-container"
            [class.center]="floatingButtonContainer | async"
            [style.width]="(hasMultiple | async) ? cardRect?.width + 'px' : '100%'"
          >
            @if (showFloatingNavigation | async) {
              @if (ss.isMobile | async) {
                <ng-container [ngTemplateOutlet]="prevButton"></ng-container>
                <ng-container [ngTemplateOutlet]="menuButton"></ng-container>
                <ng-container [ngTemplateOutlet]="nextButton"></ng-container>
              }
            } @else {
              <ng-container [ngTemplateOutlet]="requiredAnswer"></ng-container>
              <ng-container [ngTemplateOutlet]="ctaButton"></ng-container>
            }
          </div>
          <ng-container [ngTemplateOutlet]="policyText"></ng-container>
        </div>
      }
    }
  }
</div>

<ng-template #buttonWrapper let-$key>
  @if (!$key || (buttonWrapperItems | async)?.includes($key)) {
    <div
      class="z-button-wrapper z-fx-col z-fx-gap-8"
      [class.not-visible]="floatingCtaButton | async"
      [style.margin-top.px]="(ss.viewState | async) === states.Welcome ? (ss.viewRect$ | async)?.height * 0.08 : null"
    >
      <ng-container [ngTemplateOutlet]="ctaButton" [ngTemplateOutletContext]="{ $implicit: $key }"></ng-container>
      <ng-container [ngTemplateOutlet]="policyText"></ng-container>
    </div>
  }
</ng-template>

<ng-template #ctaButton let-$key>
  <ng-container [ngTemplateOutlet]="requiredAnswer"></ng-container>
  @if ((!$key || (buttonItems | async)?.includes($key)) && button | async; as buttonTexts) {
    @if (buttonTexts.text) {
      <basic-button
        class="z-basic-button"
        [class.z-error]="buttonTexts.text === 'Review'"
        [class.welcome-start-button]="(ss.viewState | async) === states.Welcome"
        [waitNext]="waitNext"
        (next)="onCtaButtonClick()"
      >
        {{ buttonTexts.text | translateText: buttonTexts.translation }}
      </basic-button>
    }
  }
  <ng-container [ngTemplateOutlet]="requiredLabel"></ng-container>
</ng-template>

<ng-template #prevButton>
  <button
    class="z-player-button"
    [disabled]="(ss.activeIdx | async) <= 0"
    [style.background-color]="(ss.colors | async).mood"
    [style.color]="(ss.colors | async).button"
    (click)="changeIdx(-1)"
  >
    <mat-icon fontSet="zefplayer">arrow_up</mat-icon>
  </button>
</ng-template>

<ng-template #nextButton>
  <button
    class="z-player-button"
    [disabled]="(ss.activeIdx | async) + 1 >= (ss.cardQuestions | async)?.length"
    [style.background-color]="(ss.colors | async).mood"
    [style.color]="(ss.colors | async).button"
    (click)="changeIdx(1)"
  >
    <mat-icon fontSet="zefplayer">arrow_down</mat-icon>
  </button>
</ng-template>

<ng-template #menuButton>
  <button
    class="z-menu-button z-player-button"
    [style.background-color]="(ss.colors | async)?.mood"
    [style.color]="(ss.colors | async)?.button"
    (click)="openMenu()"
  >
    <brand-menu></brand-menu>
  </button>
</ng-template>

<ng-template #policyText>
  @if ((showPrivacyPolicy | async) && (ss.branding | async)) {
    <div class="z-policy-container" [style.color]="(ss.colors | async).text80" @waitOut>
      <span>{{ privacyPolicyText((ss.branding | async).name) | translateText: 'privacyPolicyText' }}</span>
      @if (ss.isMobile | async) {
        <br />
      }
      <a [href]="privacyPolicyLink((ss.branding | async).domain) | translateText: 'privacyPolicyLink'" target="_blank">
        {{ 'Privacy Policy' | translateText: 'privacyPolicy' }}
      </a>
    </div>
  }
</ng-template>

<ng-template #requiredAnswer>
  @if (showIsRequired | async) {
    <div class="z-required">
      <span>*&nbsp;</span>
      <span>{{ 'This answer is requested' | translateText: 'requiredQuestion' }}</span>
    </div>
  }
</ng-template>

<ng-template #requiredLabel>
  @if ((showUnansweredLabel | async) && (requiredUnanswered | async); as unanswered) {
    <div class="z-error" @waitOut>
      @if (unanswered.length === 1) {
        1 {{ 'answer needs completing' | translateText: 'reviewSingle' }}
      }
      @if (unanswered.length > 1) {
        {{ unanswered.length }} {{ 'answers need completing' | translateText: 'reviewMulti' }}
      }
    </div>
  }
</ng-template>
